<template>
  <div class="term-and-condition-container">
    <div class="headline-m">{{ textTitleModal }}</div>
    <div class="term-content" :class="{ 'is-expanded': isExpanded }">
      <div ref="termContentBody" class="term-content-body">
        <div v-if="conditionHtml" v-html="conditionHtml"></div>
      </div>
      <span
        v-if="isOverflowing"
        class="text-label-term term-toggle"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'ย่อเนื้อหา' : 'แสดงทั้งหมด' }}
      </span>
    </div>
    <div class="term-action">
      <div class="agree-container">
        <v-checkbox
          :value="modelValue"
          :true-value="true"
          color="primary"
          :error-messages="error ? errorMessages : ''"
          :hide-details="!error"
          class="mt-0 label-l-semibold"
          @change="onChange"
        >
          <template v-slot:label>
            <span class="text-black">
              ฉันรับทราบว่าฉันได้อ่านและยอมรับ
              <span @click.stop="openLink" class="text-label-term">
                ข้อกำหนดและเงื่อนไข
              </span>
              <template v-if="!isVip()">
                การสั่งซื้อสินค้าเรียบร้อยแล้ว
              </template>
            </span>
          </template>
        </v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isBnn from '@/config/isBnn'

export default {
  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
      cartSummaryData: state => state.cart.cartSummaryData,
    }),

    conditionHtml() {
      return this.$route.query.code
        ? this.campaign?.data?.condition_html_stockcard ??
            this.campaign?.data?.condition_html
        : this.campaign?.data?.condition_html
    },

    linkTerm() {
      if (isBnn) {
        return 'https://www.bnn.in.th/th/pages/terms-of-use'
      }
      return 'https://www.studio7thailand.com/th/pages/terms-of-use'
    },

    textTitleModal() {
      return 'เงื่อนไขรายการส่งเสริมการขาย'
    },

    campaignType() {
      return process.env.VUE_APP_CAMPAIGN_TYPE ?? 'BNN'
    },
  },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  inject: ['isVip'],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isExpanded: false,
      isOverflowing: false,
    }
  },

  watch: {
    conditionHtml() {
      this.$nextTick(this.checkOverflow)
    },
  },

  mounted() {
    this.$nextTick(this.checkOverflow)
  },

  methods: {
    checkOverflow() {
      const el = this.$refs.termContentBody
      if (!el || this.isExpanded) return
      this.isOverflowing = el.scrollHeight > el.clientHeight
    },

    onChange(value) {
      this.$emit('update:modelValue', value ?? false)
    },

    openLink() {
      window.open(this.linkTerm, '_blank')
    },

    goContact() {
      this.campaignType === 'BNN'
        ? window.open(
            'https://www.facebook.com/Bananaitshop/',
            '_blank',
          )
        : window.open(
            'https://www.facebook.com/Studio7Thailand/',
            '_blank',
          )
    },
  },
}
</script>

<style lang="stylus" scoped>
.term-and-condition-container
  display: flex
  flex-direction: column
  gap: 16px
.term-content
    background-color: $color-bnn-gray-light-2
    width: 100%
    position: relative
    border-radius: 8px
	&.is-expanded
		.term-content-body
			max-height: none
			padding-bottom: 0
		.term-toggle
			position: unset
			background: none

.term-content-body
    max-height: 500px
    overflow: auto
    padding: 1rem 1rem 56px
	@media screen and (min-width: 768px){
    	max-height: 600px
	}

.term-toggle
    position: absolute
    bottom: 0
    display: inline-block
    width: 100%
    text-align: center
    margin-top: 0.5rem
    cursor: pointer
    background: linear-gradient(to bottom, rgba($color-bnn-gray-light-2, 0) 0%, rgba($color-bnn-gray-light-2, 0.5) 20%, rgba($color-bnn-gray-light-2, 1) 80%)
    padding: 1rem 0.5rem

.term-action {
    display: flex
    flex-direction: column
    width: 100%
}

.text-label-term
  color: $color-text-link
  text-decoration: underline;
  margin: 0 1px

.link
    color: #1976d2
    cursor: pointer
.text-price-lg
	font-size: 20px
	font-weight: bold
	text-overflow: ellipsis

.action-container
	display: flex
	align-items: flex-end
	justify-content: flex-end
	flex-direction: column
	gap: 20px
	// padding: 20px
	// border-top: 1px solid #f0f0f0
	@media min-medium
		flex-direction: row
	.price-container
		display: grid
		align-items: center
		grid-template-columns: repeat(1, 1fr)
		gap: 8px
		width: 100%
		@media min-medium
			gap: 0
			grid-template-columns: repeat(2, 1fr)
		.price-box
			display: flex
			justify-content: space-between
			align-items: center
			flex-flow: row wrap
			@media min-medium
				flex-flow: column wrap
				align-items: flex-start
		.price-box:nth-child(2)
			border-right: none
			@media min-medium
				padding-left: 20px
				border-left: 1px solid #f0f0f0\

	.btn-container
		width: fit-content
		max-width: 100%
.info-container
	font-size: 12px
	.v-icon
		font-size: 12px
		color: #808080


.modal-card {
    padding: 24px
    border-radius: 18px
}

.header-modal {
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 16px
}

.btn-close {
    width: 40px;
    height: 40px;
    min-width 40px

    background: #e8e8e8;
    border-radius: 50% !important;

    z-index 10

    &:hover {
        .icon-close {
            color: rgba(0,0,0,0.72)
        }
    }

    &:focus {
        outline: .125rem solid #0071e3;
        outline-offset: .125rem;
        outline-offset: .125rem;
    }

    .icon-close {
        color: rgba(18,18,18,0.56)
    }
}

.is-bnn
	.term-content
		background-color: white
	.term-toggle
		background: linear-gradient(to bottom, rgba(white, 0) 0%, rgba(white, 0.5) 20%, rgba(white, 1) 80%)
</style>
